module.exports = __webpack_public_path__ + "mm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mm.svg
// module id = 949
// module chunks = 0